module.exports = __webpack_public_path__ + "img/chicken.b11934cd.png";